import React from 'react';
import { Link } from 'react-router-dom';
import { stats } from '../data';
import '../CSS/About.css';

const skills = [
  { name: 'React / Next.js', level: 95, color: '#6366f1' },
  { name: 'TypeScript', level: 88, color: '#3b82f6' },
  { name: 'PostgreSQL / MongoDB', level: 82, color: '#fb923c' },
  { name: 'Docker / DevOps', level: 78, color: '#f472b6' },
  { name: 'Azure / Cloud', level: 75, color: '#a78bfa' },
];

const timeline = [
  { year: '2022', title: 'Started CodeWithVijay', desc: 'Began writing technical articles to share knowledge and give back to the dev community.' },
  { year: '2023', title: 'Reached 1M readers', desc: 'The blog hit a major milestone with readers from 100+ countries reading the articles.' },
  { year: '2024', title: 'Launched first course', desc: 'Published "React from Scratch" which has since been taken by 3,000+ developers.' },
  { year: '2025', title: 'YouTube Channel', desc: 'Expanded to video content with tutorials on React, Node.js, and system design.' },
  { year: '2026', title: '4M+ Readers', desc: 'Growing community of developers learning modern web development together.' },
];

const About = () => {
  return (
    <main className="about-page">
      <div className="container">

        {/* Hero */}
        <section className="about-hero">
          <div className="about-hero__avatar">
            <div className="about-hero__avatar-ring" />
            <div className="about-hero__avatar-inner">V</div>
          </div>
          <div className="about-hero__content">
            <span className="section-label">About me</span>
            <h1 className="about-hero__name">Hey, I'm Vijay 👋</h1>
            <p className="about-hero__bio">
              I'm a Full-Stack Web Developer and technical writer passionate about .Net, C# React,SQL, AI
              and modern AI Agents. I've been building web applications for 15+ years and started
              CodeWithVijay to share real-world insights, battle-tested patterns, and honest takes
              on the tools and frameworks we use every day.
            </p>
            <p className="about-hero__bio">
              When I'm not coding or writing, you'll find me contributing to open source,
              speaking at meetups, or obsessing over terminal customization.
            </p>
            <div className="about-hero__actions">
              <Link to="/contact" className="btn btn--primary">Get in Touch</Link>
              <a href="https://github.com" target="_blank" rel="noreferrer" className="btn btn--secondary">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"/></svg>
                GitHub
              </a>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="about-stats">
          {stats.map(s => (
            <div key={s.label} className="about-stat">
              <span className="about-stat__value">{s.value}</span>
              <span className="about-stat__label">{s.label}</span>
            </div>
          ))}
        </section>

        {/* Skills */}
        <section className="about-section">
          <span className="section-label">Expertise</span>
          <h2 className="section-title" style={{ marginBottom: 32 }}>Tech Stack</h2>
          <div className="skills-grid">
            {skills.map(skill => (
              <div key={skill.name} className="skill-item">
                <div className="skill-item__header">
                  <span className="skill-item__name">{skill.name}</span>
                  <span className="skill-item__level">{skill.level}%</span>
                </div>
                <div className="skill-item__bar">
                  <div className="skill-item__fill" style={{ width: `${skill.level}%`, background: skill.color }} />
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Timeline */}
        <section className="about-section">
          <span className="section-label">Journey</span>
          <h2 className="section-title" style={{ marginBottom: 40 }}>The Story So Far</h2>
          <div className="timeline">
            {timeline.map((item, i) => (
              <div key={i} className="timeline-item">
                <div className="timeline-item__year">{item.year}</div>
                <div className="timeline-item__dot" />
                <div className="timeline-item__content">
                  <h3 className="timeline-item__title">{item.title}</h3>
                  <p className="timeline-item__desc">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

      </div>
    </main>
  );
};

export default About;
